import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './styles/tokens.css';
import './styles/globals.css';
import './styles/utilities.css';
// One-time migration from pre-rebrand localStorage key (2026-04-19). Run at
// app boot (not only inside TopBar) so a pre-rebrand user who lands on
// /login or /status — routes where TopBar does not mount — still gets
// their theme preference migrated. Safe to delete this import + call after
// all active users have been migrated (est. 3 months based on session
// frequency).
import { migrateThemeKey } from '@/components/layout/themeMigration.js';

migrateThemeKey();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
